import { Button, Icons, useToggle } from '@commenda/kakashi';
import { ConfirmationModal } from '../../../../molecules/modals/ConfirmationModal';
import {
  TaskParty,
  TaskStatus,
} from '@prisma/client';
import { ServiceRequestTaskLabel } from '../../../common/labels';
import { ServiceRequestTaskIconConfig } from '../../../common/taskIconConfig';
import { ServiceRequestTaskCard } from '../../../layout/components/taskCard/ServiceRequestTaskCard';
import { ServiceRequestTaskCardConfig, TCommonTaskProp } from '../../../types';
import { updateTaskStatus } from '../../../utils';

export const MarkLLPDeedFilingTask = ({
  task,
  context,
  isTimelineView,
  displayNumber,
}: TCommonTaskProp) => {
  const { role, mutate } = context;

  const markAsFiledModalVisibility = useToggle();

  const handleMarkAsFiled = async () => {
    await updateTaskStatus({
      task,
      status: TaskStatus.COMPLETED,
      mutate,
    });
    markAsFiledModalVisibility.hide();
  };

  const config: ServiceRequestTaskCardConfig = {
    getLeftIcon: (status) => ServiceRequestTaskIconConfig[status],
    getStateConfig: (state) => {
      const stateMap = {
        [TaskParty.CLIENT]: {
          [TaskStatus.TO_DO]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel label="Agent marks update: LLP deed filed" />
            ),
          },
          [TaskStatus.COMPLETED]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel
                label="LLP deed filing submitted"
                timestamp={task.updatedAt}
                status={task.status}
              />
            ),
          },
        },
        [TaskParty.AGENT]: {
          [TaskStatus.TO_DO]: {
            actions: (
              <Button
                size="sm"
                onClick={markAsFiledModalVisibility.show}
                variant="primary"
              >
                <Icons.Check className="w-4" />
                Mark as Filled
              </Button>
            ),
            label: (
              <ServiceRequestTaskLabel label="Mark update: LLP Deed filing submitted" />
            ),
          },
          [TaskStatus.BACKLOG]: {
            actions: (
              <Button size="sm" disabled variant="primary">
                <Icons.Check className="w-4" />
                Mark as Filled
              </Button>
            ),
            label: (
              <ServiceRequestTaskLabel label="Mark update: LLP Deed filing submitted" />
            ),
          },
          [TaskStatus.COMPLETED]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel
                label="Filing Submitted"
                status={task.status}
                timestamp={task.updatedAt}
              />
            ),
          },
        },
      };

      return (
        stateMap[state.role]?.[state.status] ?? {
          label: task.title,
          actions: null,
        }
      );
    },
  };

  return (
    <div>
      <ServiceRequestTaskCard
        task={task}
        state={{
          role,
          status: task.status,
        }}
        config={config}
        context={context}
        isTimelineView={isTimelineView}
        displayNumber={displayNumber}
      />
      <ConfirmationModal
        isOpen={markAsFiledModalVisibility.visible}
        onClose={markAsFiledModalVisibility.hide}
        onConfirm={handleMarkAsFiled}
        title="Mark as filed"
        message="Please note that this action will update the customer. To revert this change, please contact Commenda Support."
        hideCancelButton
      />
    </div>
  );
};
